var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",style:(_vm.computedStyle),on:{"click":function($event){return _vm.addTag(_vm.tag.id)}}},[_c('p',[_vm._v(_vm._s(_vm.tag.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }